var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 7.5h1.666V5h2.5V3.333h-2.5v-2.5H9.167v2.5h-2.5V5h2.5v2.5zM5.833 15c-.916 0-1.658.75-1.658 1.666 0 .917.742 1.667 1.658 1.667.917 0 1.667-.75 1.667-1.667C7.5 15.75 6.75 15 5.833 15zm8.334 0c-.917 0-1.659.75-1.659 1.666 0 .917.742 1.667 1.659 1.667.916 0 1.666-.75 1.666-1.667 0-.916-.75-1.666-1.666-1.666zm-8.192-2.71l.025-.1.75-1.358h6.208c.625 0 1.175-.342 1.459-.858l3.216-5.842-1.45-.8h-.008L15.258 5l-2.3 4.166h-5.85L7 8.941 5.133 5l-.791-1.667-.784-1.667H.833v1.667H2.5l3 6.325L4.375 11.7a1.611 1.611 0 00-.208.8c0 .916.75 1.666 1.666 1.666h10V12.5h-9.65a.212.212 0 01-.208-.209z",
    fill: "currentColor"
  })));
}

export default SvgAddCart;